import { routes } from './:id'

export { routes }
